import { cognitoRefresh } from "../helpers/cognitoRefresh";

function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
}

function isExpired(token, skewSeconds = 30) {
  const payload = parseJwt(token);
  if (!payload?.exp) return true;
  const now = Math.floor(Date.now() / 1000);
  return payload.exp <= (now + skewSeconds);
}

export async function apiGet(path) {
  const base = process.env.REACT_APP_API_BASE;
  if (!base) throw new Error("Falta REACT_APP_API_BASE en .env");

  let accessToken = localStorage.getItem("accessToken") || "";

  if (!accessToken || isExpired(accessToken)) {
    await cognitoRefresh();
    accessToken = localStorage.getItem("accessToken") || "";
  }

  let res = await fetch(`${base}${path}`, {
    method: "GET",
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (res.status === 401) {
    await cognitoRefresh();
    accessToken = localStorage.getItem("accessToken") || "";
    res = await fetch(`${base}${path}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }

  const text = await res.text();
  let data;
  try { data = text ? JSON.parse(text) : {}; }
  catch { data = { raw: text }; }

  if (!res.ok) throw new Error(data?.message || `HTTP ${res.status}`);
  return data;
}
